import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  isDownloadingFile: false,
  results: {},
  error: null,
  czechDownloadXml: {
    isLoading: false,
    response: null,
    error: null,
  },
};
export default reducerFactory(initialState, {
  [types.GENERATE_VAT_RETURN_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
    results: [],
  }),
  [types.GENERATE_VAT_RETURN_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    results: response.vatReturn,
  }),
  [types.GENERATE_VAT_RETURN_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_VAT_RETURN_ENTRY_LIST_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
    results: [],
  }),
  [types.GET_VAT_RETURN_ENTRY_LIST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    results: response.vatReturn,
  }),
  [types.GET_VAT_RETURN_ENTRY_LIST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.DOWNLOAD_SAFT_REQUEST]: state => ({
    ...state,
    isDownloadingFile: true,
  }),
  [types.DOWNLOAD_OFFICIAL_XML_REQUEST]: state => ({
    ...state,
    isDownloadingFile: true,
  }),
  [types.DOWNLOAD_VAT_RETURN_REQUEST]: state => ({
    ...state,
    isDownloadingFile: true,
  }),
  [types.DOWNLOAD_FILED_RETURN_REQUEST]: state => ({
    ...state,
    isDownloadingFile: true,
  }),
  [types.DOWNLOAD_SUCCESS]: state => ({
    ...state,
    isDownloadingFile: false,
  }),
  [types.DOWNLOAD_FAILURE]: state => ({
    ...state,
    isDownloadingFile: false,
  }),
  [types.SEND_VAT_RETURN_EMAIL_REQUEST]: state => ({ ...state, error: null, isLoading: true }),
  [types.SEND_VAT_RETURN_EMAIL_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [types.SEND_VAT_RETURN_EMAIL_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_VAT_RETURN_BANK_DETAILS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [types.GET_VAT_RETURN_BANK_DETAILS_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    bankDetails: response.bankDetails,
  }),
  [types.GET_VAT_RETURN_BANK_DETAILS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_REQUEST]: state => ({
    ...state,
    error: null,
    czechDownloadXml: { isLoading: true },
  }),
  [types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_SUCCESS]: (state, { response }) => ({
    ...state,
    czechDownloadXml: {
      isLoading: false,
      response: response.economicActivityList,
    },
  }),
  [types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_FAILURE]: (state, { response }) => ({
    ...state,
    czechDownloadXml: {
      error: response.error,
    },
  }),
  [types.CLEAR_VAT_RETURN_DATA]: () => ({
    results: [],
  }),
  [types.GET_ITALY_VAT_RETURN_ENTRY_LIST_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
    results: [],
  }),
  [types.GET_ITALY_VAT_RETURN_ENTRY_LIST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    results: response.vatReturn,
  }),
  [types.GET_ITALY_VAT_RETURN_ENTRY_LIST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
